import { render, staticRenderFns } from "./MultiPointObjectiveInput.vue?vue&type=template&id=c4af80d6&"
import script from "./MultiPointObjectiveInput.vue?vue&type=script&lang=ts&"
export * from "./MultiPointObjectiveInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports